/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} User_Username_PlaceholderInputs */

const en_user_username_placeholder = /** @type {(inputs: User_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`username`)
};

const ja_user_username_placeholder = /** @type {(inputs: User_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ユーザー名`)
};

const fr_user_username_placeholder = /** @type {(inputs: User_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`nom d'utilisateur`)
};

const de_user_username_placeholder = /** @type {(inputs: User_Username_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzername`)
};

/**
* | output |
* | --- |
* | "username" |
*
* @param {User_Username_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const user_username_placeholder = /** @type {((inputs?: User_Username_PlaceholderInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<User_Username_PlaceholderInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_user_username_placeholder(inputs)
	if (locale === "ja") return ja_user_username_placeholder(inputs)
	if (locale === "fr") return fr_user_username_placeholder(inputs)
	return de_user_username_placeholder(inputs)
});